import { InjectionToken } from '@angular/core';
import type { Params } from '@angular/router';
import type { MenuItemType } from '@shared/types/layout';

export interface AppMenuNavigation {
  hasSubMenu(item: MenuItemType): boolean;
  toggleMenu(item: MenuItemType): void;
  shouldHighlightParent(item: MenuItemType): boolean;
  isActive(item: MenuItemType): boolean;
  getRouterLink(item: MenuItemType): string[];
  getQueryParams(item: MenuItemType): Params | null;
  getIconSrc(item: MenuItemType): string | null;
}

export const APP_MENU_NAVIGATION = new InjectionToken<AppMenuNavigation>('APP_MENU_NAVIGATION');
